import React, { useEffect, useState, useRef } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import { MaterialDatePickerField } from 'Components/Inputes/MaterialDatePickerField';
import { SelectUserForDropDownForCashCollection as USER_SELECT_FOR_DROPDOWN } from 'Components/Api/UsersApi';
import AsyncAutoComplete from 'Components/Inputes/AsyncAutoComplete';
import ReactTable from 'Components/ReactTable/ReactTable';
import CircularProgress from '@material-ui/core/CircularProgress';

import { Container, Grid, Paper, MenuItem, Box } from '@material-ui/core';

import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { PLEASE_SELECT_VALID, RETAILER_CODE } from 'Components/Helper/Messages';
import Accordion from '@material-ui/core/Accordion';
import { SelectByFilter as SEARCH } from 'Components/Api/CashCollectionAPI';
import HOCLoader from 'Components/Loader/HOCLoader';
import { Select as SELECT_PAYMENT_MODE } from 'Components/Api/PaymentModesAPI';
import HOCAccordion from 'Components/CustomAccordion/HOCAccordion';
import { PrimaryButton } from 'Components/Inputes/CustomButton';
import { ExportTypeItems } from 'Components/ReportHelper';
import { HeaderCashCollectionSummary } from 'Components/SummaryCards/HeaderCashCollectionSummary';

const CustomAccordion = HOCAccordion(Accordion);
const CustomContainer = HOCLoader(Container);

export const CashCollectionReportV2 = () => {
    const formRef = useRef();
    const [list, setList] = useState([]);
    const [mainColumns, setMainColumns] = useState([]);
    const [loadingOpen, setLoadingOpen] = React.useState(false);
    const classes = commonStyle();
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [downline, setDownline] = useState([]);
    const [IsRetailerRole, setIsRetailerRole] = useState(false);
    const [paymentModes, setpaymentModes] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [TakeCount, setTakeCount] = useState(10);
    const [SkipCount, setSkipCount] = useState(0);
    const [headerSummary, setHeaderSummary] = useState({});
    var currentUsertypeid = localStorage.getItem('UserTypeID');

    const CheckUserRole = () => {
        if (RETAILER_CODE === parseInt(currentUsertypeid))
            setIsRetailerRole(true);
    };
    const [userDefault, setUserDefault] = useState({
        UserID: 0,
        FirmName: 'Select All'
    });

    var formObj = {
        FromDate: new Date(),
        ToDate: new Date(),
        User: userDefault,
        Type: 'CASH COLLECTION DECREASED',
        ExportType: 'Select Download',
        PayMode: 'All'
    };

    useEffect(() => {
        setLoadingOpen(false);
        selectPaymentModes();
        CheckUserRole();
        createColumns();
    }, []);

    const selectPaymentModes = async () => {
        const response = await SELECT_PAYMENT_MODE();

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);
            return;
        }

        var data = JSON.parse(response.data);
        setpaymentModes(data);
    };

    const PayModeList = paymentModes.map(({ PaymentModeMasterID, Type }) => (
        <MenuItem key={PaymentModeMasterID} value={Type}>
            {Type}
        </MenuItem>
    ));

    const resetToast = () => {
        setIsError(false);
        setResponseMessage('');
    };

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        var inputObj = {
            FromDate: values.FromDate,
            ToDate: values.ToDate,
            UserID: values.User.UserID,
            Type: values.Type,
            ExportType: values.ExportType,
            PayMode: values.PayMode
        };
        setList([]);
        var requestObj = JSON.stringify(inputObj);

        if (SkipCount <= 0) {
            setHeaderSummary({});
        }
        setLoadingOpen(true);
        resetToast();
        var response = await SEARCH(requestObj);
        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }
        var list = JSON.parse(response.data);
        if (list.IsDownload) {
            downloadFile(list.ReportPath, 'Collection Report');
            return;
        }

        if (SkipCount <= 0) {
            setHeaderSummary(list.HeaderSummary);
            setTotalCount(list.Count);
        }
        setList(list.data);
    };
    function downloadFile(URL, Title) {
        let a = document.createElement('a');
        a.href = URL;
        a.setAttribute('download', Title);
        a.setAttribute('target', '_blank');
        a.click();
    }
    const SelectUser = async (values) => {
        setLoadingOpen(true);
        var request = JSON.stringify(values);

        const userResponse = await USER_SELECT_FOR_DROPDOWN(request);
        setLoadingOpen(false);
        if (!userResponse.isAuthorized) LOGOUT();

        if (!userResponse.status) {
            setIsError(true);
            setSeverity('error');
            return;
        }
        var data = JSON.parse(userResponse.data);
        let objWithSelectAll = [userDefault, ...data];

        setDownline(objWithSelectAll);
    };

    const validationSchema = Yup.object({
        User: Yup.object()
            .nullable(PLEASE_SELECT_VALID + 'User')
            .required(PLEASE_SELECT_VALID + 'User')
            .shape({
                UserID: Yup.number()
                    .nullable(PLEASE_SELECT_VALID + 'User')
                    .min(0, PLEASE_SELECT_VALID + 'User')
                    .notOneOf(['0'], PLEASE_SELECT_VALID + 'User')
                    .required(PLEASE_SELECT_VALID + 'User')
            }),
        FromDate: Yup.date()
            .nullable(PLEASE_SELECT_VALID + 'from date')
            .required(PLEASE_SELECT_VALID + 'from date')
            .max(new Date(), PLEASE_SELECT_VALID + 'from date')
            .typeError(PLEASE_SELECT_VALID + 'from date'),
        ToDate: Yup.date()
            .nullable(PLEASE_SELECT_VALID + 'to date')
            .required(PLEASE_SELECT_VALID + 'to date')
            .max(new Date(), PLEASE_SELECT_VALID + 'to date')
            .typeError(PLEASE_SELECT_VALID + 'to date')
    });

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'SRNO',
            srno: true
        });
        columns.push({
            label: 'Date',
            name: 'DOC'
        });
        columns.push({
            label: 'User',
            name: 'FirmName'
        });
        columns.push({
            label: 'Parent',
            name: 'ParentFirmName'
        });

        columns.push({
            label: 'Op.Outstanding',
            name: 'OutstandingOpening',
            numeric: true
        });
        columns.push({
            label: 'Amount',
            name: 'OutstandingAmount',
            numeric: true
        });
        columns.push({
            label: 'Outstanding',
            name: 'OutstandingClosing',
            numeric: true
        });
        columns.push({
            label: 'Type',
            name: 'Type',
            customStatus: true
        });
        columns.push({
            label: 'PayMode',
            name: 'PayMode'
        });
        columns.push({
            label: 'Credit',
            name: 'Credit'
        });
        columns.push({
            label: 'Debit',
            name: 'Debit'
        });
        columns.push({
            label: 'Remark',
            name: 'ParentRemark'
        });
        columns.push({
            label: 'UTRNumber',
            name: 'UTRNumber'
        });

        setMainColumns(columns);
    };

    const [openFilter, setopenFilter] = useState(true);

    const callSearch = async (text) => {
        if (
            text === undefined ||
            text === null ||
            text === '' ||
            text.length <= 0 ||
            text === userDefault.FirmName
        )
            return;

        var jsonObj = {
            FirmName: text
        };
        SelectUser(jsonObj);
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                initialValues={formObj}
                validationSchema={validationSchema}
                onSubmit={submithandle}
                resetForm={formObj}
                render={({
                    values,
                    setFieldValue,
                    handleChange,
                    handleSubmit
                }) => {
                    return (
                        <Form>
                            <Grid item xs={12}>
                                <Paper>
                                    <CustomAccordion
                                        title={'Cash Collection Report'}
                                        open={openFilter}
                                        setOpen={(value) =>
                                            setopenFilter(value)
                                        }
                                    >
                                        <Grid container spacing={2}>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                lg={2}
                                            >
                                                <MaterialDatePickerField
                                                    name="FromDate"
                                                    label="FromDate"
                                                    maxDate={new Date()}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                lg={2}
                                            >
                                                <MaterialDatePickerField
                                                    name="ToDate"
                                                    label="ToDate"
                                                    maxDate={new Date()}
                                                />
                                            </Grid>
                                            {!IsRetailerRole ? (
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={2}
                                                    lg={2}
                                                >
                                                    <Field
                                                        component={
                                                            AsyncAutoComplete
                                                        }
                                                        defaultValue={
                                                            userDefault
                                                        }
                                                        FieldName="User"
                                                        name="User"
                                                        SubFieldName="UserID"
                                                        options={downline}
                                                        getOptionLabel={(
                                                            option
                                                        ) => option.FirmName}
                                                        textFieldProps={{
                                                            label: 'Select User'
                                                        }}
                                                        onSearchCallback={(
                                                            text
                                                        ) => {
                                                            callSearch(text);
                                                        }}
                                                        onCustomCallback={(
                                                            name,
                                                            value
                                                        ) => {
                                                            setUserDefault({
                                                                UserID:
                                                                    value.UserID,
                                                                FirmName:
                                                                    value.FirmName
                                                            });
                                                        }}
                                                    />
                                                </Grid>
                                            ) : null}
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                lg={2}
                                            >
                                                <MaterialSelect
                                                    label="Type"
                                                    name="Type"
                                                >
                                                    <MenuItem
                                                        key="All"
                                                        value="All"
                                                    >
                                                        Select All
                                                    </MenuItem>
                                                    <MenuItem
                                                        key="CASH COLLECTION INCREASED"
                                                        value="CASH COLLECTION INCREASED"
                                                    >
                                                        Increased
                                                    </MenuItem>
                                                    <MenuItem
                                                        key="CASH COLLECTION DECREASED"
                                                        value="CASH COLLECTION DECREASED"
                                                    >
                                                        Decreased
                                                    </MenuItem>
                                                    <MenuItem
                                                        key="CASH COLLECTION REVERSE"
                                                        value="CASH COLLECTION REVERSE"
                                                    >
                                                        Reverse
                                                    </MenuItem>
                                                </MaterialSelect>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                lg={2}
                                            >
                                                <MaterialSelect
                                                    label="Pay Mode"
                                                    name="PayMode"
                                                    title="Select Mode"
                                                >
                                                    <MenuItem
                                                        key="All"
                                                        value="All"
                                                    >
                                                        Select Mode
                                                    </MenuItem>
                                                    {PayModeList}
                                                </MaterialSelect>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                lg={2}
                                            >
                                                <MaterialSelect
                                                    label="ExportType"
                                                    name="ExportType"
                                                    title="ExportType"
                                                >
                                                    {ExportTypeItems}
                                                </MaterialSelect>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={1}
                                                lg={1}
                                            >
                                                <PrimaryButton
                                                    type="submit"
                                                    title="Search"
                                                    className={
                                                        classes.CustomPrimaryButtonStyle
                                                    }
                                                    disabled={loadingOpen}
                                                >
                                                    Search
                                                </PrimaryButton>
                                                {loadingOpen && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={
                                                            classes.buttonProgress
                                                        }
                                                    />
                                                )}
                                            </Grid>
                                        </Grid>
                                    </CustomAccordion>
                                </Paper>
                            </Grid>
                            <Grid className={classes.footerGrid}>
                                <Box className={classes.flexReverse}>
                                    <div
                                        className={classes.SubmitWrapper}
                                    ></div>
                                </Box>
                            </Grid>
                        </Form>
                    );
                }}
            />
            <HeaderCashCollectionSummary headerSummary={headerSummary} />
            <ReactTable
                data={list}
                columns={mainColumns}
                getCallback={({ currentPage, RowsPerPage }) => {
                    setTakeCount(RowsPerPage);
                    setSkipCount(RowsPerPage * currentPage);
                }}
                count={totalCount}
                rowsPerPage={10}
            />
        </CustomContainer>
    );
};
